import SmButton from './sm-button/sm-button';
import SmAccordion from './sm-accordion/sm-accordion';
import SmImageOverlay from './sm-image-overlay/sm-image-overlay';
import SmCustomSelect from './sm-custom-select/sm-custom-select';
import SmStepper from './sm-stepper/sm-stepper';
import SmPortal from './sm-portal/sm-portal';

const components = [
    SmButton,
    SmAccordion,
    SmImageOverlay,
    SmCustomSelect,
    SmStepper,
    SmPortal,
];

const init = () => {
    components.forEach(initialize => {
        initialize();
    });
};

window.addEventListener('sm:component:update', init);

init();
